const getters = {
  token: (state) => state.user.token,
  userInfo: (state) => state.user.userInfo,
  companyName: (state) => state.user.companyName,
  userRole: (state) => state.user.userRole,
  companyList: (state) => state.user.companyList,
  isCompanyCertified: (state) => {
    const companyList =
      state.user.companyList || state.user.userInfo?.company?.companyList || [];
    return Array.isArray(companyList) && companyList.length > 0;
  },
  activeNav: (state) => state.app.activeNav,
  themeKey: (state) => state.app.themeKey,
  insuranceOptions: (state) => state.page.insuranceOptions,
  educationOptions: (state) => state.page.educationOptions,
  workTypeOptions: (state) => state.page.workTypeOptions,
  departmentOptions: (state) => state.page.departmentOptions,
  orderTypeOptions: (state) => state.page.orderTypeOptions,
  orderStatusOptions: (state) => state.page.orderStatusOptions,
  workTypeLabel: (state) => (value) => {
    console.log(value);
    const findLabel = (options) => {
      if (!Array.isArray(options)) return "";
      for (const item of options) {
        if (item.children && item.children.length) {
          const found = findLabel(item.children);
          if (found) return found;
        }
        if (item.value === value || item.value_name === value) {
          return item.value_name;
        }
      }
      return "";
    };
    return findLabel(state.page.workTypeOptions);
  },
  workTypeValue: (state) => (label) => {
    const findValue = (options) => {
      if (!Array.isArray(options)) return "";
      for (const item of options) {
        if (item.children && item.children.length) {
          const found = findValue(item.children);
          if (found) return found;
        }
        if (item.value_name === label) {
          return item.value;
        }
      }
      return "";
    };
    return findValue(state.page.workTypeOptions);
  },
  messageStatistics: (state) => state.page.messageStatistics,
};

export default getters;